/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON, FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON, } from './FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromSocialResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromSocialResponse(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    if (!('AuthenticatedSocialIdentifierType' in value) || value['AuthenticatedSocialIdentifierType'] === undefined)
        return false;
    if (!('AuthenticatedSocialIdentifier' in value) || value['AuthenticatedSocialIdentifier'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'AccountId': json['AccountId'],
        'AuthenticatedSocialIdentifierType': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON(json['AuthenticatedSocialIdentifierType']),
        'AuthenticatedSocialIdentifier': json['AuthenticatedSocialIdentifier'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'AccountId': value['AccountId'],
        'AuthenticatedSocialIdentifierType': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON(value['AuthenticatedSocialIdentifierType']),
        'AuthenticatedSocialIdentifier': value['AuthenticatedSocialIdentifier'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialResponse.js.map